import { render, staticRenderFns } from "./masrufi.vue?vue&type=template&id=4289694a&"
import script from "./masrufi.vue?vue&type=script&lang=js&"
export * from "./masrufi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports